<template>
	<v-card outlined>
		<v-card-title v-text="'Tester'" class="justify-center body-1 secondary pa-1 ">
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col md="2">
					<v-card outlined>
						<v-card-title
							v-text="'List to test'"
							class="justify-center caption pa-1 info"
						></v-card-title>
						<v-list>
							<template v-for="item_btn of selects">
								<v-list-item @click="render_selected(item_btn.name)">
									<v-list-item-title v-text="item_btn.name"></v-list-item-title>								
								</v-list-item>
							</template>
						</v-list>

					</v-card>
				</v-col>
				<v-col md="10">
					<v-card outlined>
						<v-card-title
							v-text="'Information'"
							class="justify-center caption pa-1 primary"
						></v-card-title>
						<v-card-text>
							{{ inf }}
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-card-text>
		<template >			
			<alert_lpr
				key="alert"
				:alert="inf"
				@close="inf=$event"
				is_from="alert"
				:is_sound_active="true"
				@check_modal="close_modal($event)"
			></alert_lpr>
		</template>
		<template >			
			<!-- <show_data_sz
			></show_data_sz> -->
		</template>
	</v-card>
</template>
<script>
import axios from 'axios'
// import alert_lpr from '@/components/lpr/alert.vue'
// import show_data_sz from '@/components/safe_zone/show_data.vue'
import info_alert from '@/components/tester/jsons/alert_json_1.json'
	export default{
		name: 'tester',
		components:{
			alert_lpr, show_data_sz, info_alert
		}, // componentes
		data: vm => ({
			inf: null,
			select: '',
			list: [],
			selects:[
				{ name: 'Information' },
				{ name: 'Alert LPR' },
				{ name: 'Alert SZ'},
			],//
			is_open_modal: false,
		}), // data
		created(){
			// this.get_list();
			for (var i = 0; i < 30; i++) {
				this.list.push(info_alert)

			}
			// var vm=this;
			// setInterval(() =>{			
			// 	if (this.list.length>0) {
				
			// 		// console.log(this.data_alert.length, 'lenght created')
			// 		if (!this.is_open_modal ) {

			// 			console.log(vm.list, ' inteval ')
			// 			let dato=vm.list.shift();
			// 			// console.log(dato, 'dato a enviar');
						
			// 			if (dato && dato.type=='alert') {
			// 				vm.inf=dato;
			// 				this.is_open_modal=true;
			// 			}
			// 			// if (dato && dato.is_alertgun) {
			// 			// 	vm.item_alertgun=dato;
			// 			// 	this.is_open_modal=true;
			// 			// }

			// 			// console.log('interval created');
			// 		}
			// 	}		
			// }, 2000);
		}, // created

		methods:{
			get_list(item=''){
				if (item=='alert_lpr_json') {
					this.inf=info_alert;
					this.is_open_modal=true;										
				}
				// axios.defaults.withCredentials=true;
				/*fetch('../components/tester/jsons/'+item).then(res => {
					console.log(res, 'res fetch')
					this.inf=res;
				})*/
			}, // get list
			render_selected(item){
				if (item=='Information') {
					this.get_list('alert_lpr_json');
					
				}
				if (item=='Alert LPR') {
					// if (!this.is_open_modal){
						
						this.select='Alert_lpr';	
						this.inf=info_alert;
						// this.is_open_modal=true;
					// }
				
					// this.get_list('alert_lpr_json');
				}
			}, // render selected
			close_modal(val){
				this.is_open_modal=val;
				this.select='';
			}
		}, // methods
		mounted(){
			// ws://202.126.92.138/ws/events/a37b3e9c83e14e1d89751ecb8a7d7250/
			// navigator.mediaDevices.enumerateDevices()
			//   .then(gotDevices)
			//   .catch(errorCallback);

			// function gotDevices(deviceInfos) {


			//     console.log(deviceInfos, 'media')

			// 	}
			console.log(navigator, 'media navigator')
			/*navigator.getUserMedia({audio: true}, function(e){

			       // http://stackoverflow.com/q/15993581/1008999
			       //
			       // In chrome, If your app is running from SSL (https://),
			       // this permission will be persistent.
			       // That is, users won't have to grant/deny access every time.
			       // localStorage.setItem("voice_access", "granted");
			       console.log(e, 'media')

			}, function(err){
				console.log(err, 'error media')
			       if(err.name == "PermissionDismissedError"){
			           // localStorage.setItem("voice_access", "prompt");
			       }
			       if(err.name == "PermissionDeniedError"){
			           // localStorage.setItem("voice_access", "denied");
			       }
			});*/

		}
	};
</script>